module.exports = __webpack_public_path__ + "img/10-03_Inspiring A Future.3ee10afe.svg";